const digitsRE = /(\d{3})(?=\d)/g;
Date.prototype.Format = function (fmt) {
    let o = {
        'M+': this.getMonth() + 1,//月份
        'd+': this.getDate(),//日
        'h+': this.getHours(),//小时
        'm+': this.getMinutes(),//分
        's+': this.getSeconds(),//秒
        'q+': Math.floor((this.getMonth() + 3) / 3),//季度
        'S+': this.getMilliseconds()//毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (let k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(('' + o[k]).length)));
    return fmt;
};

export default{
    install(Vue,options)
    {
        //公用过滤器1
        Vue.filter('isSpecialPhone', function (num) {
            return /^1[3,4,5,7,8]\d{9}$/.test(num);
        });
        Vue.filter('isName', function (name) {
            return /[a-zA-Z\u4E00-\u9FA5]+$/.test(name);
        });
        Vue.filter('isMoney', function (n) {
            return /^\d+$/.test(n);
        });
        Vue.filter('trim', function (str) {
            return str.replace(/(^\s*)|(\s*$)/g, '');
        });
        Vue.filter('currency', function (value, currency, decimals) {    //用法：{{ num | currency('￥', 4) }}
            value = parseFloat(value);
            if (!isFinite(value) || (!value && value !== 0)) return '';
            currency = currency != null ? currency : '$';
            decimals = decimals != null ? decimals : 2;
            let stringified = Math.abs(value).toFixed(decimals);
            let _int = decimals
                ? stringified.slice(0, -1 - decimals)
                : stringified;
            let i = _int.length % 3;
            let head = i > 0
                ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
                : '';
            let _float = decimals
                ? stringified.slice(-1 - decimals)
                : '';
            let sign = value < 0 ? '-' : '';
            return sign + currency + head +
                _int.slice(i).replace(digitsRE, '$1,') +
                _float
        });
        //公用方法1
        Vue.prototype.toStringTwo=(str)=>(
            ('0000'+String(str)).slice(-2)  
        );

        //公用过滤器2 & 公用方法2
        Vue.mixin({
            methods:{
                a: function(){
                    console.log('a')
                },
                aa:function(){
                    console.log('aa')
                }
            },
            filters:{
                formatDateD: function (value) {
                    return new Date(value).Format("yyyy-MM-dd");
                },
                formatDateMD: function (value) {
                    return new Date(value).Format("MM月dd日");
                },
                formatDate: function (value) {
                    return new Date(value).Format("yyyy-MM-dd hh:mm:ss");
                },
                formatDateD: function (value) {
                    return new Date(value).Format("yyyy-MM-dd");
                },
                formatDateT: function (value) {
                    return new Date(value).Format("hh:mm:ss");
                },
                formatDateZn: function (value) {
                    return new Date(value).Format("yyyy年MM月dd日 hh时mm分ss秒");
                },
                formatDateZnD: function (value) {
                    return new Date(value).Format("yyyy年MM月dd日");
                },
                formatDateZnT: function (value) {
                    return new Date(value).Format("hh时mm分ss秒");
                }
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/assets/js-plug-in-unit/vue-commot.js